import { RXDB_DISEASE_COLLECTION_NAME } from "$global-providers/rxdb-provider/collections/disease";
import type { PatientClinicalResource } from "$routes/patient/[:patientId]/_lib/clinical-decision-support-service/db/collections/patient-clinical-resource";
import { FHIRResourceTypes } from "../../_lib/clinical-decision-support-service/db/collections/common";

export const mapDiseaseToPatientClinicalResource = (
  diseaseCode: string,
  userId: string,
): Omit<PatientClinicalResource, "id" | "patient" | "submissionStatus"> => {
  const currentDateTime = new Date().toISOString();
  return {
    fhirResource: {
      resourceType: FHIRResourceTypes[RXDB_DISEASE_COLLECTION_NAME],
      diagnosticReport: null,
      externalCoding: {
        snomed: null,
        icd11: {
          uri: mapDiseaseCodeToUri(diseaseCode),
        },
        icd10: null,
        loinc: null,
        elephantInternal: null,
      },
    },
    meta: {
      createdAt: currentDateTime,
      updatedAt: currentDateTime,
      createdByUserId: userId,
      updatedByUserId: userId,
    },
  };
};

// TODO eng-4756 - Elephant current diseases collection is a superset of ICD-11 augmented with some Elephant concepts with a custom code as their icd11 code
// This function distinguishes between the two for easier future refactoring
export const mapDiseaseCodeToUri = (diseaseCode: string) =>
  diseaseCode.startsWith("$")
    ? `http://elephant.healthcare/${diseaseCode}`
    : `https://id.who.int/icd/entity/${diseaseCode}`;
